import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade médico). */
export type CertidaoCancelamentoMedicoJob = ReportJob;
export type CertidaoCancelamentoMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão de Cancelamento (Médico). */
@Injectable({ providedIn: 'root' })
export class CertidaoCancelamentoMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-cancelamento-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.certidaoCancelamentoMedico;
}
